/* eslint-disable sort-keys */
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

function getMoneyFormatWithoutSpanAndNoDecimals() {
  let moneyFormat = Shopify.money_format.replace('amount', 'amount_no_decimals');
  const firstSymbolOfMoneyIndex = moneyFormat.indexOf('>') + 1;
  const lastSymbolOfMoneyIndex = moneyFormat.indexOf('</');

  if (lastSymbolOfMoneyIndex !== -1) {
    moneyFormat = moneyFormat.slice(firstSymbolOfMoneyIndex, lastSymbolOfMoneyIndex);
  }

  return moneyFormat;
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

function getComparedPricesFromLocalStorage() {
  const storedComparedCartItemPrices = localStorage.getItem('comparedPricesOfCartItems');
  // add check try catch
  return JSON.parse(storedComparedCartItemPrices) ? JSON.parse(storedComparedCartItemPrices) : {};
}

function addComparedVariantPriceToLocalStorage(variantWithComparedPriceObj) {
  const storedComparedCartItemPrices = getComparedPricesFromLocalStorage();
  const variantsToAdd = Object.keys(variantWithComparedPriceObj);

  variantsToAdd.forEach((variantId) => {
    if (!storedComparedCartItemPrices[variantId]) {
      storedComparedCartItemPrices[variantId] = variantWithComparedPriceObj[variantId];
    }
  });

  localStorage.setItem('comparedPricesOfCartItems', JSON.stringify(storedComparedCartItemPrices));
}

function removeComparedVariantPriceToLocalStorage(variantId) {
  const storedComparedCartItemPrices = getComparedPricesFromLocalStorage();
  if (!storedComparedCartItemPrices[variantId]) return;

  delete storedComparedCartItemPrices[variantId];
  localStorage.setItem('comparedPricesOfCartItems', JSON.stringify(storedComparedCartItemPrices));
}

function getCentsNumber(comparedPriceText) {
  const onlyDigitsRegex = /\d+/g;
  return comparedPriceText.match(onlyDigitsRegex)
    ? Number(comparedPriceText.match(onlyDigitsRegex).join(''))
    : undefined;
}

ShopifyAPI.updateCartNote = function (note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function (cart) {
        if (typeof callback === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      },
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var $body = $(document.body),
    serializedData = (function buildSerializedData() {
      var fields = jQuery(form).serializeArray();
      try {
        var hasEarlyBird = fields.some(function (f) {
          return f.name === 'properties[_EarlyBird]';
        });
        if (hasEarlyBird) {
          var noteEl = document.querySelector('.earlybird__f_note');
          if (noteEl) {
            fields.push({ name: 'properties[_EarlyBirdNote]', value: noteEl.innerHTML });
            fields.push({
              name: 'properties[Expected ship date]',
              value: window.Shopify.themeSettings.earlybirdShipDate || 'before Christmas',
            });
          }
        }
      } catch (e) {}
      return jQuery.param(fields);
    })(),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: serializedData,
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        const comparedPriceWrap = form.querySelector('[data-price-compared]')
          ? form.querySelector('[data-price-compared]')
          : form.closest('.quick-shop')?.querySelector('[data-price-compared]');

        if (comparedPriceWrap) {
          const comparedPriceText = comparedPriceWrap.innerText;
          let comparedPrice = getCentsNumber(comparedPriceText);
          const accessoriesEl = document.querySelector('product-accessories');
          if (accessoriesEl) {
            comparedPrice -= Number(accessoriesEl.dataset.totalPrice);
          }

          if (comparedPrice)
            addComparedVariantPriceToLocalStorage({
              [line_item.variant_id]: comparedPrice,
            });
        }

        if (typeof callback === 'function') {
          callback(line_item, form, 'addedFromForm');
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }

        if (
          line_item.properties &&
          line_item.selling_plan_allocation &&
          line_item.properties._EarlyBird === 'Pre-order'
        ) {
          document.dispatchEvent(new Event('showPreorderPopup'));
          return;
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function (XMLHttpRequest, textStatus) {
        if (typeof errorCallback === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      },
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback, type) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    $(document.body).trigger('cartReceived.ajaxCart', cart);
    if (typeof callback === 'function') {
      callback(cart, type);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback, id, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
        
        // Store info about item being removed for accessory cleanup
        if (quantity === 0) {
          const itemRow = document.querySelector(`[data-line="${line}"]`);
          if (itemRow) {
            window.removingItemVariantId = itemRow.dataset.variantId;
          }
        }
      },
      success: function (cart) {
        const complementaryCheckbox = document.querySelector(
          `.product-add__checkbox.complementary[data-variant-id="${id}"]`
        );
        const complementaryCheckboxLabel = document.querySelector(
          `.product-add__checkbox[data-variant-id="${id}"] + label`
        );
        const complementaryQuantityInput = document.querySelector(
          `.product-add__quantity-input.complementary[data-variant-id="${id}"]`
        );
        const complementaryQuantityInputWrapper = complementaryQuantityInput?.closest(
          '.product-add__quantity-wrap.complementary'
        );

        if (
          complementaryCheckbox &&
          complementaryCheckboxLabel &&
          complementaryQuantityInput &&
          complementaryQuantityInputWrapper
        ) {
          complementaryQuantityInput.value = quantity;
          complementaryQuantityInput.dataset.cartQuantity = quantity;
          complementaryCheckbox.dataset.cartQuantity = quantity;

          if (quantity <= 0) {
            complementaryCheckbox.checked = false;
            complementaryCheckboxLabel.classList.remove('dark-color', 'is-added');
            complementaryQuantityInputWrapper.classList.add('product-add__quantity-wrap--hidden');
          }
        }

        if (quantity === 0) {
          const variantIdToRemove = document.querySelector(`[data-line="${line}"]`)?.dataset.variantId;
          if (variantIdToRemove) removeComparedVariantPriceToLocalStorage(variantIdToRemove);

          // Remove related accessories when main product is removed
          const removedItemVariantId = window.removingItemVariantId;
          if (removedItemVariantId) {
            // Get fresh cart data to find accessories
            fetch(window.Shopify.routes.root + 'cart.js')
              .then(response => response.json())
              .then(freshCart => {
                
                // Find accessories in fresh cart items
                const accessoriesToRemove = freshCart.items.filter(item => {
                  const hasAccessoryProperty = item.properties && item.properties._accessory;
                  
                  // Try both string and number comparison
                  const isAccessoryOfRemovedItem = hasAccessoryProperty && 
                    (item.properties._accessory === removedItemVariantId || 
                     Number(item.properties._accessory) === Number(removedItemVariantId));
                  
                  return isAccessoryOfRemovedItem;
                });

                if (accessoriesToRemove.length > 0) {
                  // Remove all accessories at once using cart/update.js
                  const updates = accessoriesToRemove.reduce((acc, accessoryItem) => {
                    acc[accessoryItem.key] = 0;
                    return acc;
                  }, {});
                  
                  fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ updates }),
                  }).then((response) => response.json()).then((updatedCart) => {
                    delete window.removingItemVariantId;
                    const cartAfterRemoval =
                      updatedCart && typeof updatedCart.item_count === 'number' ? updatedCart : cart;
                    if (typeof callback === 'function') {
                      const updateType = quantity === 0 ? 'update' : 'updateButNotDelete';
                      callback(cartAfterRemoval, updateType);
                    } else {
                      ShopifyAPI.onCartUpdate(cartAfterRemoval);
                    }
                  }).catch(error => {
                    console.error('Error removing accessories:', error);
                    delete window.removingItemVariantId;
                    if (typeof callback === 'function') {
                      const updateType = quantity === 0 ? 'update' : 'updateButNotDelete';
                      callback(cart, updateType);
                    } else {
                      ShopifyAPI.onCartUpdate(cart);
                    }
                  });
                  return; // Exit early
                } else {
                  // No accessories found, continue normally
                  delete window.removingItemVariantId;
                  if (typeof callback === 'function') {
                    const updateType = quantity === 0 ? 'update' : 'updateButNotDelete';
                    callback(cart, updateType);
                  } else {
                    ShopifyAPI.onCartUpdate(cart);
                  }
                }
              })
              .catch(error => {
                console.error('Error fetching fresh cart:', error);
                delete window.removingItemVariantId;
                if (typeof callback === 'function') {
                  const updateType = quantity === 0 ? 'update' : 'updateButNotDelete';
                  callback(cart, updateType);
                } else {
                  ShopifyAPI.onCartUpdate(cart);
                }
              });
            return; // Exit early, callback will be called after processing
          }
        }

        if (typeof callback === 'function') {
          const updateType = quantity === 0 ? 'update' : 'updateButNotDelete';
          callback(cart, updateType);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);

        $('.ajaxcart__row[data-line="' + line + '"]').removeClass('is-loading');
        if (typeof errorCallback === 'function') {
          errorCallback();
        }
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
        isUpdating = false;
      },
    };
  jQuery.ajax(params);
};

const showCartMsg = function (cart) {
  const allMessages = document.querySelectorAll('cart-message');
  allMessages.forEach((message) => {
    message.remove();
  });

  const itemCounts = cart.items.reduce((acc, item) => {
    acc[item.id] = (acc[item.id] || 0) + item.quantity;
    return acc;
  }, {});

  const cartMsg = (window.theme.cart_msg || '').trim();
  const hasHighQuantityItem = Object.values(itemCounts).some((count) => count > 1);
  if (hasHighQuantityItem && cartMsg) {
    document
      .querySelector('.ajaxcart__head')
      .insertAdjacentHTML('afterend', `<cart-message>${cartMsg}</cart-message>`);
  }
};

document.addEventListener('cartOpened', function () {
  ShopifyAPI.getCart(showCartMsg);
});

$(document.body).on('cartReceived.ajaxCart', function (event, cart) {
  showCartMsg(cart);
});

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, isAdding, $body;

  let onCartInit;
  let ifTheFirstTimeCartIsBuild = true;

  let addGiftProductToCart = () => Promise.resolve();
  let removeGiftProductsFromCart = () => Promise.resolve();

  let giftProductSettingsList = [];
  let freeBookSettings = {};
  let recommendationSettings = {};
  let recommendationProductsData;

  let giftVariantData = null;
  let isGiftProductValid;
  let isHaveAccessory;
  let freeBookAvailableVariantsWithDemo;
  let areFreeBooksAvailable;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer,
    $emptySelector,
    $triggerSelector;

  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    calcTextAreaHeight,
    adjustCartCallback,
    createQtySelectors,
    qtySelectors,
    validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      triggerSelector: null,
      emptySelector: '#EmptyCart',
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true,
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $emptySelector = $(settings.emptySelector);
    $triggerSelector = $(settings.triggerSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;
    isAdding = false;

    // Parse both gift product settings from a single DOM element
    giftProductSettingsList = [];
    const cartDrawerGiftSettingsEl = document.getElementById('gift-cart-drawer-settings');
    if (cartDrawerGiftSettingsEl) {
      // Helper to check if all required fields are present and non-empty
      function isGiftValid(fields) {
        return fields.every((f) => f !== undefined && f !== null && f !== '' && !(typeof f === 'number' && isNaN(f)));
      }

      // First gift product
      const firstGift = {
        giftProductName: cartDrawerGiftSettingsEl.dataset.giftName,
        giftProductQuantity: Number(cartDrawerGiftSettingsEl.dataset.giftQuantity),
        giftProductVariantId: Number(cartDrawerGiftSettingsEl.dataset.giftVariant),
        giftCardsProductType: cartDrawerGiftSettingsEl.dataset.giftCardsProductType,
        totalPriceInCartToGetGift: Shopify.currency.rate * Number(cartDrawerGiftSettingsEl.dataset.giftTotal),
      };
      if (
        isGiftValid([
          firstGift.giftProductName,
          firstGift.giftProductQuantity,
          firstGift.giftProductVariantId,
          firstGift.totalPriceInCartToGetGift,
        ])
      ) {
        giftProductSettingsList.push(firstGift);
      }

      // Second gift product
      const secondGift = {
        giftProductName: cartDrawerGiftSettingsEl.dataset.gift2Name,
        giftProductQuantity: Number(cartDrawerGiftSettingsEl.dataset.gift2Quantity),
        giftProductVariantId: Number(cartDrawerGiftSettingsEl.dataset.gift2Variant),
        giftCardsProductType: cartDrawerGiftSettingsEl.dataset.giftCardsProductType, // Use same as first if needed
        totalPriceInCartToGetGift: Shopify.currency.rate * Number(cartDrawerGiftSettingsEl.dataset.gift2Total),
      };
      if (
        isGiftValid([
          secondGift.giftProductName,
          secondGift.giftProductQuantity,
          secondGift.giftProductVariantId,
          secondGift.totalPriceInCartToGetGift,
        ])
      ) {
        giftProductSettingsList.push(secondGift);
      }

      // Recommendation and free book settings (from first gift)
      recommendationSettings = {
        showRecommendation: cartDrawerGiftSettingsEl.dataset.recShow,
        variantsMode: cartDrawerGiftSettingsEl.dataset.recVariantsMode,
      };
      freeBookSettings = {
        freeBookVariantIds: cartDrawerGiftSettingsEl.dataset.freeBookVariantIds
          .split(',')
          .map((variant) => Number(variant)),
      };
    }

    const addRemoveListenersOnCartPage = () => {
      const checkoutBtnElems = document.querySelectorAll('.cart__button > button');
      const removeBtnElems = document.querySelectorAll('.cart-item__remove');

      removeBtnElems.forEach((removeBtn) =>
        removeBtn.addEventListener('click', () => {
          checkoutBtnElems.forEach((btn) => (btn.disabled = true));
        })
      );
    };

    addRemoveListenersOnCartPage();

    const getVariantData = async (variantId) => {
      try {
        const variantRes = await fetch(window.Shopify.routes.root + `variants/${variantId}.js`);

        if (variantRes.ok) {
          const variantData = await variantRes.json();
          return variantData;
        }

        return;
      } catch (error) {
        console.error('Error:', error);
      }
    };

    // For multiple gifts: fetch variant data and check validity for each
    const defineGiftVariantsDataList = async () => {
      return await Promise.all(
        giftProductSettingsList.map(async (gift) => {
          if (!gift.giftProductVariantId) return null;
          return await getVariantData(gift.giftProductVariantId);
        })
      );
    };

    const checkIfGiftVariantExistsAndIsValidList = (giftVariantDataList) => {
      return giftProductSettingsList.map((gift, idx) => {
        const giftVariantData = giftVariantDataList[idx];
        return (
          gift.giftProductVariantId &&
          gift.totalPriceInCartToGetGift &&
          gift.giftProductQuantity &&
          giftVariantData &&
          giftVariantData.available
        );
      });
    };

    const defineFreeBooksVariantsData = async () => {
      const freeBookVariantsData = await Promise.all(
        freeBookSettings.freeBookVariantIds.map(async (freeBookVariantId) => {
          const freeBookData = await getVariantData(freeBookVariantId);
          return freeBookData;
        })
      );

      return freeBookVariantsData;
    };

    const defineFreeBooksValidVariantsWithDemo = async () => {
      const freeBookVariantsData = await defineFreeBooksVariantsData();

      return freeBookVariantsData.reduce((acc, variantData) => {
        const demoCodeMarkup = document.querySelector(`template#free_book_demo_code_${variantData?.id}`);

        if (variantData && variantData.available && demoCodeMarkup) {
          return [
            ...acc,
            {
              variantId: variantData.id,
              comparedPrice: variantData.compare_at_price,
              demoCodeMarkup,
            },
          ];
        }

        return acc;
      }, []);
    };

    const addGiftProductsComparedPriceToLocalStorage = (giftVariantDataList) => {
      const variantsComparedPrices = freeBookAvailableVariantsWithDemo.reduce((acc, availableVariantData) => {
        return availableVariantData.comparedPrice
          ? { ...acc, [availableVariantData.variantId]: availableVariantData.comparedPrice }
          : acc;
      }, {});
      giftVariantDataList.forEach((giftVariantData) => {
        if (giftVariantData && giftVariantData.compare_at_price) {
          variantsComparedPrices[giftVariantData.id] = giftVariantData.compare_at_price;
        }
      });
      addComparedVariantPriceToLocalStorage(variantsComparedPrices);
    };

    const createAPIFunctionsForGifts = () => {
      addGiftProductToCart = async (items) => {
        const formData = {
          items,
        };

        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          });
        } catch (error) {
          console.error('Error:', error);
        }
      };

      removeGiftProductsFromCart = async (variantKeys) => {
        const updates = variantKeys.reduce((acc, key) => ({ ...acc, [key]: 0 }), {});
        if (!Object.keys(updates).length) return;

        try {
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          });
        } catch (error) {
          console.error('Error:', error);
        }
      };
    };

    onCartInit = async () => {
      // For multiple gifts
      window.giftVariantDataList = await defineGiftVariantsDataList();
      
      window.isGiftProductValidList = checkIfGiftVariantExistsAndIsValidList(window.giftVariantDataList);

      freeBookAvailableVariantsWithDemo = await defineFreeBooksValidVariantsWithDemo();
      areFreeBooksAvailable = freeBookAvailableVariantsWithDemo.length > 0;

      if (window.isGiftProductValidList.some(Boolean) || areFreeBooksAvailable) createAPIFunctionsForGifts();
      addGiftProductsComparedPriceToLocalStorage(window.giftVariantDataList);
    };

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  function cartCountLabel(count) {
    const strings = window.cartStrings || {};
    if (count === 1 && strings.cartCountOne) {
      return strings.cartCountOne;
    }
    if (strings.cartCountOther && strings.cartCountOther.indexOf('99999') !== -1) {
      return strings.cartCountOther.replace('99999', String(count));
    }
    return String(count);
  }

  function updateCartCountBubbles(count) {
    const label = cartCountLabel(count);

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      let digits = bubble.querySelector('[aria-hidden="true"]');

      if (count < 100) {
        if (!digits) {
          digits = document.createElement('span');
          digits.setAttribute('aria-hidden', 'true');
          bubble.insertBefore(digits, bubble.firstChild);
        }
        digits.textContent = String(count);
      } else if (digits) {
        digits.remove();
      }

      const srText = bubble.querySelector('.visually-hidden');
      if (srText) srText.textContent = label;
    });

    document.querySelectorAll('.js-cart-icon, #cart-icon-bubble').forEach(function (icon) {
      icon.classList.toggle('js-cart-full', count > 0);
    });
  }

  updateCountPrice = function (cart) {
    updateCartCountBubbles(cart.item_count);

    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  const stripEarlyBirdProps = (obj) => {
    const keys = ['Purchase option', '_EarlyBird', '_EarlyBirdCampaign', '_EarlyBirdNote', 'Expected ship date'];
    keys.forEach((k) => delete obj[k]);
  };

  formOverride = function () {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      if (!(document.querySelector('.complementary-products__list') || document.querySelector('.accessories__list'))) {
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      } else {
        const currentProductVariant = Number(document.querySelector('[name="id"]').value);
        const currentProductComparedPriceText = evt.currentTarget.querySelector('[data-price-compared]')?.innerText;
        let currentProductComparedPrice = getCentsNumber(currentProductComparedPriceText);
        const accessoriesEl = document.querySelector('product-accessories');
        if (accessoriesEl) {
          currentProductComparedPrice -= Number(accessoriesEl.dataset.totalPrice);
        }

        const formData = new FormData(evt.target);
        const mainItemProperties = {};
        let mainItemQuantity = 1;
        let mainItemSellingPlan;

        formData.forEach((value, key) => {
          if (key === 'quantity') {
            const parsed = Number(value);
            if (!Number.isNaN(parsed) && parsed > 0) {
              mainItemQuantity = parsed;
            }
          } else if (key === 'selling_plan' || key === 'selling_plan_id') {
            mainItemSellingPlan = value;
          } else {
            const match = key.match(/^properties\[(.*)\]$/);
            if (match && match[1] && !(value instanceof File)) {
              mainItemProperties[match[1]] = value;
            }
          }
        });

        if (mainItemProperties._EarlyBird) {
          const earlyBirdNoteEl = document.querySelector('.earlybird__f_note');
          if (earlyBirdNoteEl) {
            mainItemProperties._EarlyBirdNote = earlyBirdNoteEl.innerHTML;
            mainItemProperties['Expected ship date'] =
              window.Shopify.themeSettings.earlybirdShipDate || 'before Christmas';
          }
        }

        const mainItem = {
          id: currentProductVariant,
          quantity: mainItemQuantity,
          properties: mainItemProperties,
        };

        if (mainItemSellingPlan) {
          mainItem.selling_plan = mainItemSellingPlan;
        } else {
          stripEarlyBirdProps(mainItem.properties);
        }

        const complementaryProductsData = { items: [mainItem] };
        const complementaryProductsComparedPriceToSaveInLocalStorage = {
          [currentProductVariant]: currentProductComparedPrice,
        };
        const checkedComplementaryProductsCheckboxElems = document.querySelectorAll(
          '.product-add__checkbox.accessories:checked'
        );

        checkedComplementaryProductsCheckboxElems.forEach((checkboxEl) => {
          const complementaryItemEl = checkboxEl.closest('.complementary-products__item');
          const complementaryItemComparedPriceText =
            complementaryItemEl.querySelector('[data-price-compared]')?.innerText;
          const currentProductComparedPrice = getCentsNumber(complementaryItemComparedPriceText);
          const complementaryIdEl = complementaryItemEl.querySelector('[name="complementary-id"]');
          const accessoryIdEl = complementaryItemEl.querySelector('[name="accessory-id"]');

          const variantId = Number(complementaryIdEl.value != 0 ? complementaryIdEl.value : accessoryIdEl.value);
          const variantQuantity = Number(
            complementaryItemEl.querySelector('[name="complementary-quantity"], [name="accessory-quantity"]')?.value
          );
          const preorderSellingPlan = complementaryItemEl.querySelector(
            '.complementary_product_inner[data-preorder-selling-plan]'
          )?.dataset.preorderSellingPlan;

          complementaryProductsComparedPriceToSaveInLocalStorage[variantId] = currentProductComparedPrice;
          if (complementaryItemEl.dataset.accessory != undefined) {
            const mainItem = complementaryProductsData.items.find((item) => item.id === currentProductVariant);
            let fastShippingCount = Number(document.querySelector('product-accessories')?.dataset.fastShippingCount);
            if (fastShippingCount) {
              mainItem.properties._max_accessory = fastShippingCount;
            }
          }

          const baseProperties =
            complementaryItemEl.dataset.accessory != undefined
              ? { _accessory: currentProductVariant }
              : { _upsell: 'upsell' };

          const properties =
            mainItemSellingPlan && preorderSellingPlan
              ? {
                  ...baseProperties,
                  _EarlyBird: 'Pre-order',
                  _EarlyBirdCampaign: 'Pre-order',
                  _EarlyBirdNote: 'Pre-order',
                  'Purchase option': 'Pre-order',
                  'Expected ship date': window.Shopify.themeSettings.earlybirdShipDate || 'before Christmas',
                }
              : baseProperties;

          const itemData = {
            id: variantId,
            properties,
            quantity: variantQuantity,
          };

          if (mainItemSellingPlan && preorderSellingPlan) {
            itemData.selling_plan = preorderSellingPlan;
          }

          complementaryProductsData.items.unshift(itemData);
        });

        const addProductWithComplementary = () => {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(complementaryProductsData),
          }).then((res) => {
            const addingBtnEl = document.querySelector('.product-form__add-btn.is-adding');
            addingBtnEl.classList.remove('is-adding');
            addingBtnEl.classList.add('is-added');

            addComparedVariantPriceToLocalStorage(complementaryProductsComparedPriceToSaveInLocalStorage);
            ShopifyAPI.getCart(cartUpdateCallback, 'addedWithComplementary');

            if (document.querySelector('product-accessories')?.dataset.showPopup === 'true') {
              $body[0].dispatchEvent(new Event('showCongratulationsPopup'));
            } else {
              if (mainItem.properties && mainItem.properties._EarlyBird === 'Pre-order') {
                document.dispatchEvent(new Event('showPreorderPopup'));
                return;
              }
              $body.trigger('afterAddItem.ajaxCart');
            }
          });
        };

        addProductWithComplementary();
      }
    });
  };

  var thisProduct = {};
  itemAddedCallback = function (product, form, type) {
    var thisAddToCart = $(form).find(settings.addToCartSelector);

    // Add class to be styled if desired
    thisAddToCart.removeClass('is-adding').addClass('is-added');

    // removes button styling when animation finishes
    form.querySelector('.js-product-add.is-added').addEventListener(
      'animationend',
      function () {
        thisAddToCart.removeClass('is-added');
      },
      { once: true }
    );
    // removes button styling if mouse leaves quick shop
    if (form.classList.contains('product-form--card')) {
      form.closest('.product-card--modal').addEventListener(
        'mouseleave',
        function () {
          thisAddToCart.removeClass('is-added');
        },
        { once: true }
      );
    }

    thisProduct = product;

    ShopifyAPI.getCart(cartUpdateCallback, type);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
      }
    }
  };

  cartUpdateCallback = function (cart, type) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart, type);
  };

  window.ShopifyAPIGetCartCartCallback = function () {
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  const productCache = {};

  async function getProduct(productHandle) {
    if (!productHandle) return null;
    if (Object.prototype.hasOwnProperty.call(productCache, productHandle)) {
      return productCache[productHandle];
    }

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      productCache[productHandle] = product;
      return product;
    } catch (error) {
      console.error('Error fetching product:', error);
      productCache[productHandle] = null;
      return null;
    }
  }

  async function getProductOptions(productHandle) {
    const product = await getProduct(productHandle);
    return (product && product.options) || [];
  }

  function isVariantUnavailable(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return false;
    const variant = product.variants.find(function (v) {
      return v.id === variantId;
    });
    return !!variant && variant.available === false;
  }
  
  function filterVariantTitle(variantTitle, productOptions) {
    if (!variantTitle || !productOptions || productOptions.length === 0) {
      return variantTitle;
    }
    
    const goesWithIndex = productOptions.findIndex(opt => opt.name === 'Goes with' || opt === 'Goes with');
    if (goesWithIndex === -1) {
      return variantTitle;
    }
    
    const options = variantTitle.split(' / ');
    const filteredOptions = options.filter((_, index) => index !== goesWithIndex);
    return filteredOptions.join(' / ');
  }

  buildCart = async function (cart, type) {
    $body.off('change', '.ajaxcart__recomendations-select');

    // Start with a fresh cart div
    let cartItems = cart.items;
    let cartData = cart;
    let giftCardInCart;
    let recommendationsWithCustomVariants;

    // Show empty cart
    if (cartData.item_count === 0) {
      $(settings.emptySelector).show();
      $(settings.triggerSelector).removeClass('js-cart-full');
      $(settings.cartContainer).hide();
      cartCallback(cartData);
      return;
    } else {
      $(settings.emptySelector).hide();
      $(settings.cartContainer).addClass('is-updating');
      $(settings.cartContainer).show();
      $(settings.triggerSelector).addClass('js-cart-full');
    }

    // Handlebars.js cart layout
    var cartItemsForTemplate = [],
      obj = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);

    Handlebars.registerHelper('orCondition', function (v1, v2, v3) {
      return v1 || v2 || v3;
    });

    Handlebars.registerHelper('greater', function (v1, v2) {
      return v1 > v2;
    });

    Handlebars.registerHelper('formatMoney', function (price, moneyFormat) {
      if (moneyFormat === 'no_decimals') {
        const moneyFormatWithNoDecimals = getMoneyFormatWithoutSpanAndNoDecimals();
        return Shopify.formatMoney(price, moneyFormatWithNoDecimals);
      }
      return Shopify.formatMoney(price);
    });

    Handlebars.registerHelper('countDiscount', function (originalPrice, salePrice, type = 'percentage') {
      let moneyFormat = Shopify.money_format.replace('amount', 'amount_no_decimals');
      const firstSymbolOfMoneyIndex = moneyFormat.indexOf('>') + 1;
      const lastSymbolOfMoneyIndex = moneyFormat.indexOf('</');

      if (lastSymbolOfMoneyIndex !== -1) {
        moneyFormat = moneyFormat.slice(firstSymbolOfMoneyIndex, lastSymbolOfMoneyIndex);
      }

      return originalPrice && salePrice
        ? type === 'percentage'
          ? `save ${Math.round((salePrice / originalPrice) * 100)}%`
          : `save ${Shopify.formatMoney(Math.floor((originalPrice - salePrice) / 100) * 100, moneyFormat)}`
        : '';
    });

    Handlebars.registerHelper('getVariantImageSrc', function (product) {
      return product.featured_image
        ? product.featured_image
        : 'http://cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
    });

    Handlebars.registerHelper('checkIfDisabled', function (isAvailable) {
      return isAvailable ? '' : 'disabled';
    });

    Handlebars.registerHelper('defineAddBtnText', function (isAvailable) {
      return isAvailable ? 'Add to cart' : 'Out of stock';
    });

    Handlebars.registerHelper('defineStarStatus', function (reviewsRate, starIndex) {
      if (!reviewsRate || !reviewsRate.total_reviews) return 'ajaxcart__recomendations-stars-item--empty-plug';
      if (starIndex <= reviewsRate.average_score) {
        return 'ajaxcart__recomendations-stars-item--full';
      } else if (!Number.isInteger(starIndex - reviewsRate)) {
        return starIndex - reviewsRate.average_score < 1
          ? 'ajaxcart__recomendations-stars-item--half'
          : 'ajaxcart__recomendations-stars-item--empty';
      } else {
        return 'ajaxcart__recomendations-stars-item--empty';
      }
    });

    // Helper to check if any value in an array is true (for isGift array)
    Handlebars.registerHelper('anyTrue', function (arr) {
      return Array.isArray(arr) && arr.some(Boolean);
    });

    if (ifTheFirstTimeCartIsBuild) {
      await onCartInit();
      ifTheFirstTimeCartIsBuild = false;
    }

    const accessoryItems = cartItems.filter((item) => item.properties._accessory);

    if (accessoryItems.length) {
      let accessoriesDataToRemove = [];

      for (let index = 0; index < accessoryItems.length; index++) {
        const relatedProduct = cartItems.find(
          (item) => item.id === Number(accessoryItems[index].properties._accessory)
        );

        if (!relatedProduct) {
          accessoriesDataToRemove.push(accessoryItems[index].key);
        }
      }

      if (accessoriesDataToRemove.length) {
        await removeGiftProductsFromCart(accessoriesDataToRemove);
      }
    }

    // Multi-gift logic
    if (window.isGiftProductValidList && window.giftVariantDataList) {
      for (let i = 0; i < giftProductSettingsList.length; i++) {
        if (!window.isGiftProductValidList[i]) continue;
        const gift = giftProductSettingsList[i];
        const giftVariantData = window.giftVariantDataList[i];
        const giftProductVariantInCart = cartItems.find(
          (cartItem) => cartItem.variant_id === gift.giftProductVariantId
        );
        const freeGiftThresholdIsReached = cartData.total_price / 100 >= gift.totalPriceInCartToGetGift;

        if (gift.giftCardsProductType) {
          giftCardInCart = cartData.items.find((cartItem) => cartItem.product_type === gift.giftCardsProductType);
        }

        let shouldFreeGiftBeAdded = freeGiftThresholdIsReached && !giftProductVariantInCart;
        let shouldFreeGiftBeRemoved = !freeGiftThresholdIsReached && giftProductVariantInCart;

        if (gift.giftCardsProductType) {
          shouldFreeGiftBeAdded = shouldFreeGiftBeAdded && !giftCardInCart;
          shouldFreeGiftBeRemoved =
            shouldFreeGiftBeRemoved || (freeGiftThresholdIsReached && giftProductVariantInCart && giftCardInCart);
        }

        if (shouldFreeGiftBeAdded) {
          await addGiftProductToCart([
            {
              id: gift.giftProductVariantId,
              quantity: gift.giftProductQuantity ? gift.giftProductQuantity : 1,
            },
          ]);
        } else if (shouldFreeGiftBeRemoved) {
          await removeGiftProductsFromCart([...[], giftProductVariantInCart.key]);
        }
      }
    }

    if (areFreeBooksAvailable) {
      const res = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartDataFromRes = await res.json();

      const freeBooksInCart = cartItems.filter(
        (cartItem) =>
          cartItem.properties._gift &&
          freeBookSettings.freeBookVariantIds.find((variantId) => variantId === cartItem.variant_id)
      );
      const discountIsNotApplied = freeBooksInCart.find((freeBook) => freeBook.final_line_price > 0);
      const freeBooksInCartKeys = freeBooksInCart.map((freeBookItem) => freeBookItem.key);
      const freeBookVariantsInCart = cartItems.filter((cartItem) =>
        freeBookSettings.freeBookVariantIds.find((variantId) => variantId === cartItem.variant_id)
      );

      const checkIfOnlyGiftsAreInCart = () => {
        const allGiftsVariants = [
          ...giftProductSettingsList.map((gift) => ({ id: gift.giftProductVariantId })),
          ...freeBookAvailableVariantsWithDemo.map((bookVariantData) => ({
            id: bookVariantData.variantId,
            isBook: true,
          })),
        ];

        return cartItems.reduce((acc, cartItem) => {
          return acc
            ? allGiftsVariants.find((giftVariant) => {
                const isGift = cartItem.id === giftVariant.id;
                if (!isGift || !giftVariant.isBook) return isGift;

                return cartItem.properties._gift;
              })
            : acc;
        }, true);
      };

      const hasOtherProductExceptGiftBooks = cartData.items.reduce((acc, cartItem) => {
        return acc
          ? acc
          : !freeBookSettings.freeBookVariantIds.find((freeBookVariantId) => cartItem.id === freeBookVariantId);
      }, false);

      const areNoGiftBooksInCart =
        cartData.total_price > 0 && !freeBooksInCart.length && !freeBookVariantsInCart.length;
      const areGiftBookVariantsInCartButNotFree =
        cartData.total_price > 0 &&
        freeBookVariantsInCart.length &&
        hasOtherProductExceptGiftBooks &&
        (!freeBooksInCart.length || discountIsNotApplied);

      if (checkIfOnlyGiftsAreInCart()) {
        await removeGiftProductsFromCart(freeBooksInCartKeys);
      } else if (areNoGiftBooksInCart) {
        await addGiftProductToCart(
          freeBookAvailableVariantsWithDemo.reduce((acc, book) => {
            const variantToAddData = { id: book.variantId, quantity: 1, properties: { _gift: 'gift' } };
            return [...acc, variantToAddData];
          }, [])
        );
      } else if (areGiftBookVariantsInCartButNotFree) {
        const bookVariantKeysInCart = freeBookVariantsInCart.map((bookItem) => bookItem.key);

        await removeGiftProductsFromCart(bookVariantKeysInCart);
        await addGiftProductToCart(
          freeBookAvailableVariantsWithDemo.reduce((acc, book) => {
            const variantToAddData = { id: book.variantId, quantity: 1, properties: { _gift: 'gift' } };
            return [...acc, variantToAddData];
          }, [])
        );
      }
    }

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartDataFromRes = await res.json();

      cartData = cartDataFromRes;
      cartItems = cartDataFromRes.items.map((item, index) => ({ ...item, line_index: index + 1 }));
      if (isGiftProductValid || areFreeBooksAvailable) {
        const sortCartItemsWithGiftProductsAtTheEnd = () => {
          return [...cartItems].sort((item, nextItem) => {
            const isGift =
              giftProductSettingsList.some((gift) => nextItem.id === gift.giftProductVariantId) ||
              freeBookSettings.freeBookVariantIds.find((freeBookVarinatId) => freeBookVarinatId === nextItem.id);
            return isGift ? -1 : 0;
          });
        };

        cartItems = sortCartItemsWithGiftProductsAtTheEnd();
      }
      const sortAccessoryCartItems = () => {
        return [...cartItems].sort((item, nextItem) => {
          const isAccessory = item.properties && item.properties._accessory !== undefined;
          const nextIsAccessory = nextItem.properties && nextItem.properties._accessory !== undefined;

          const itemMainId = isAccessory ? item.properties._accessory : item.id;
          const nextMainId = nextIsAccessory ? nextItem.properties._accessory : nextItem.id;

          if (itemMainId !== nextMainId) {
            return itemMainId - nextMainId;
          }

          if (isAccessory !== nextIsAccessory) {
            return isAccessory ? 1 : -1;
          }

          return 0;
        });
      };

      cartItems = sortAccessoryCartItems();
    } catch (error) {
      console.error(error);
    }

    if (!cartItems.length) {
      const updateBtnEl = document.querySelector('.cart__button-update');
      if (updateBtnEl) updateBtnEl.click();
    } else {
      const checkoutBtnElems = document.querySelectorAll('[data-section-type="cart-page"] .cart__button > button');
      checkoutBtnElems.forEach((btn) => (btn.disabled = false));
    }

    const getReviewsStatistics = async (productId) => {
      try {
        const res = await fetch(
          `https://api.yotpo.com/products/F2MNMTj0CrP63wTeiMZns70weIpB1oOvqL8n2UaB/${productId}/bottomline`
        );

        const data = await res.json();
        return data?.response?.bottomline;
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (recommendationSettings.showRecommendation === 'true' && cartItems[0]) {
      const getRecommendationProducts = async (productId) => {
        try {
          const res = await fetch(
            window.Shopify.routes.root +
              `recommendations/products.json?product_id=${productId}&limit=4&intent=complementary`
          );
          const recommendationsData = await res.json();
          return recommendationsData;
        } catch (error) {
          console.error(error);
        }
      };

      if (type != 'updateButNotDelete') {
        recommendationProductsData = await getRecommendationProducts(cartItems[0].product_id);
        recommendationProductsData = await Promise.all(
          recommendationProductsData?.products.map(async (recProduct) => {
            const reviews = await getReviewsStatistics(recProduct.id);
            return reviews ? { ...recProduct, customReviews: reviews } : { ...recProduct };
          })
        );
      }

      const chooseRecommendationProductVariant = (e) => {
        const chosenVarianTitle = e.target.value;
        const recommendationCardEl = e.target.closest('[data-product-id]');
        const addToCartBtnEl = recommendationCardEl.querySelector('.ajaxcart__recomendations-add-btn');
        const currentProductId = Number(recommendationCardEl.dataset.productId);
        let recProductData;

        if (recommendationSettings.variantsMode === 'general') {
          recProductData = recommendationProductsData
            .find((product) => product.id === currentProductId)
            .variants.find((variant) => variant.title === chosenVarianTitle);
        } else {
          const selectsElems = recommendationCardEl
            .querySelector('.ajaxcart__recomendations-products')
            .querySelectorAll('select');
          const selectsValues = {};

          selectsElems.forEach((select) => {
            const selectTitle = select.dataset.selectTitle;
            const selectValue = select.value;
            selectsValues[selectTitle] = selectValue;
          });
          const variantFullTitle = Object.values(selectsValues).join(' / ');

          recProductData = recommendationProductsData
            .find((product) => product.id === currentProductId)
            .variants.find((variant) => variant.title === variantFullTitle);
        }

        const moneyFormatWithNoDecimals = getMoneyFormatWithoutSpanAndNoDecimals();
        const discountValue = Math.floor((recProductData.compare_at_price - recProductData.price) / 100) * 100;

        if (!recProductData.available) {
          addToCartBtnEl.disabled = true;
          addToCartBtnEl.innerText = 'Out of stock';
        } else {
          addToCartBtnEl.disabled = false;
          addToCartBtnEl.innerText = 'Add to cart';
        }

        recommendationCardEl.dataset.variantId = recProductData.id;
        recommendationCardEl.querySelector('.ajaxcart__recomendations-product-original').innerText =
          Shopify.formatMoney(recProductData.price);
        recommendationCardEl.querySelector('.ajaxcart__recomendations-product-sale').innerText = Shopify.formatMoney(
          recProductData.compare_at_price
        );
        recommendationCardEl.querySelector(
          '.ajaxcart__recomendations-product-discount'
        ).innerText = `save ${Shopify.formatMoney(discountValue, moneyFormatWithNoDecimals)}`;
      };

      const addRecommendationProductToCart = async (e) => {
        e.preventDefault();

        const comparedPriceWrap = e.target.closest('[data-variant-id]')?.querySelector('[data-price-compared]');

        if (comparedPriceWrap) {
          const comparedPriceText = comparedPriceWrap.innerText;
          const comparedPrice = getCentsNumber(comparedPriceText);

          addComparedVariantPriceToLocalStorage({
            [Number(e.target.closest('[data-variant-id]').dataset.variantId)]: comparedPrice,
          });
        }

        if (isUpdating && isAdding) {
          return;
        }

        $cartContainer.removeClass('is-loading');

        const recommendationVariantId = e.target.closest('[data-product-id]').dataset.variantId;
        const formData = {
          items: [
            {
              id: recommendationVariantId,
              properties: {
                _upsell: 'upsell',
              },
              quantity: 1,
            },
          ],
        };

        try {
          isUpdating = true;
          isAdding = true;
          e.target.classList.add('is-loading');
          e.target.innerText = 'Adding to cart';
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            body: JSON.stringify(formData),
            headers: {
              'Content-Type': 'application/json',
            },
            method: 'POST',
          });

          ShopifyAPI.getCart(buildCart, 'cartRecommendationAdded');
        } catch (error) {
          console.error('Error:', error);
        } finally {
          isUpdating = false;
          isAdding = false;
        }
      };

      const variantsForSelect = [];

      if (recommendationProductsData) {
        if (recommendationSettings.variantsMode === 'general') {
          recommendationProductsData.forEach((product, index) => {
            const allVariantsTitles = product.variants.map((variant) => variant.title);

            if (allVariantsTitles.length <= 1 && allVariantsTitles[0] === 'Default Title') {
              variantsForSelect[index] = { [product.id]: [] };
              return;
            }

            const availableProductVariants = product.variants.filter((variant) => variant.available);

            variantsForSelect[index] = {
              [product.id]: [
                {
                  name: 'Variants',
                  values: availableProductVariants.map((variant) => variant.title),
                },
              ],
            };
          });
        } else {
          recommendationProductsData.forEach((product, index) => {
            variantsForSelect[index] = { [product.id]: [] };
            product.options.forEach((selectName, indexOfOption) => {
              if (selectName.name === 'Title') return;
              variantsForSelect[index][product.id][indexOfOption] = selectName;
            });
          });
        }

        recommendationsWithCustomVariants = recommendationProductsData.map((rec) => {
          const variantsForCurrentProductSelect = variantsForSelect.find((variant) => variant[rec.id]);
          const firstAvailableChosenVariant = rec.variants.find((variant) => variant.available === true);

          if (!variantsForCurrentProductSelect) return;
          return {
            ...rec,
            customerVariantsForSelect: variantsForCurrentProductSelect[rec.id],
            firstAvailableChosenVariant,
          };
        });
      }

      $body.on('change', '.ajaxcart__recomendations-select', chooseRecommendationProductVariant);
      // $body.on('click', '.ajaxcart__recomendations-add-btn', addRecommendationProductToCart);
    }

    // Show empty cart
    if (cartItems?.length === 0) {
      $(settings.emptySelector).show();
      $(settings.triggerSelector).removeClass('js-cart-full');
      $(settings.cartContainer).hide();
      cartCallback(cartData);
      return;
    } else {
      $(settings.emptySelector).hide();
      $(settings.cartContainer).show();
      $(settings.triggerSelector).addClass('js-cart-full');
    }
    // Gather all cart data and add to DOM

    for (const cartItem of cartItems) {
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_240x240_crop_center$1').replace('http:', '');
      } else {
        var prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }
      const isDoubled = cartItems.filter((item) => item.id === cartItem.id).length > 1;
      // For multiple gifts, isGift is an array of booleans, one per gift
      const isGift = giftProductSettingsList.map((gift) => cartItem.variant_id === gift.giftProductVariantId);
      const isFreeBook =
        cartItem.properties._gift &&
        freeBookSettings.freeBookVariantIds.find((variantId) => cartItem.variant_id === variantId);
      const isAccessory = cartItem.properties._accessory != undefined;

      const isPreorder =
        (cartItem.properties && cartItem.properties._EarlyBird === 'Pre-order') ||
        (cartItem.properties && cartItem.properties['Purchase option'] === 'Pre-order');

      let comparePrice = getComparedPricesFromLocalStorage()[cartItem.variant_id] || 0;
      let price = cartItem.final_price || 0;
      let linePrice = cartItem.final_line_price || 0;
      let lineTotalComparePrice = (getComparedPricesFromLocalStorage()[cartItem.variant_id] || 0) * cartItem.quantity;

      if (isPreorder && cartItem.selling_plan_allocation) {
        try {
          if (cartItem.selling_plan_allocation.compare_at_price) {
            comparePrice = cartItem.selling_plan_allocation.compare_at_price;
          }
          if (cartItem.selling_plan_allocation.price) {
            price = cartItem.selling_plan_allocation.price;
            linePrice = cartItem.selling_plan_allocation.price * cartItem.quantity;
          }
          if (cartItem.selling_plan_allocation.compare_at_price) {
            lineTotalComparePrice = cartItem.selling_plan_allocation.compare_at_price * cartItem.quantity;
          }
        } catch (e) {
          console.log('Error processing selling_plan_allocation:', e);
        }
      }

      const isHaveFastShipping = () => {
        if (cartItem.properties._max_accessory == undefined || isAccessory) {
          return false;
        }
        const accessoryItems = cartItems.filter((item) => item.properties._accessory === cartItem.id);
        const allAccessoriesMatchQuantity = accessoryItems.every((item) => item.quantity === cartItem.quantity);

        return allAccessoriesMatchQuantity && accessoryItems.length === cartItem.properties._max_accessory;
      };

      const productHandle = cartItem.url ? cartItem.url.split('/products/')[1]?.split('?')[0] : null;
      const productData = productHandle ? await getProduct(productHandle) : null;
      const productOptions = (productData && productData.options) || [];
      const filteredVariation = filterVariantTitle(cartItem.variant_title, productOptions);
      const isUnavailable = isVariantUnavailable(productData, cartItem.variant_id);

      obj = {
        comparePrice: comparePrice,
        discounts: cartItem.discounts || [],
        id: cartItem.variant_id,
        img: prodImg,
        isDoubled,
        isAccessory,
        isFreeBook,
        isPreorder: isPreorder || false,
        isUnavailable,
        expectedShipDate:
          cartItem.properties && cartItem.properties['Expected ship date']
            ? cartItem.properties['Expected ship date']
            : null,
        productType: cartItem.product_type,
        isHaveFastShipping,
        isGift, // now an array of booleans, one per gift
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        key: cartItem.key,
        line: cartItem.line_index, // Shopify uses a 1+ index in the API
        linePrice: linePrice,
        lineTotalComparePrice: lineTotalComparePrice,
        name: cartItem.product_title,
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney(cartItem.original_price, settings.moneyFormat),
        price: Shopify.formatMoney(price, settings.moneyFormat),
        properties: cartItem.properties || {},
        url: cartItem.url,
        variation: filteredVariation,
        vendor: cartItem.vendor,
      };

      cartItemsForTemplate.push(obj);
    }

    const totalComparePrice = cartItemsForTemplate.reduce(
      (acc, item) => (item.lineTotalComparePrice ? acc + item.lineTotalComparePrice : acc + item.linePrice),
      0
    );

    const ceilNumber = (number, digits = 2) => {
      const formattedNumberWithDigits = (Math.ceil(number * 100) / 100).toFixed(digits);
      return Math.floor(formattedNumberWithDigits) === Math.ceil(formattedNumberWithDigits)
        ? Math.ceil(formattedNumberWithDigits)
        : formattedNumberWithDigits;
    };

    // For multiple gifts, build an array of gift badge data for all valid gifts
    const validGiftBadges = giftProductSettingsList.map((gift, idx) => {
      const giftVariantData = window.giftVariantDataList ? window.giftVariantDataList[idx] : null;
      return {
        giftProductName: gift.giftProductName,
        freeGiftVariantImage: giftVariantData?.featured_image?.src
          ? giftVariantData.featured_image.src
          : 'http://cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif',
        sumLeftToGetGiftProduct:
          gift.totalPriceInCartToGetGift - cartData.total_price / 100 >= 0
            ? ceilNumber(gift.totalPriceInCartToGetGift - cartData.total_price / 100) * 100
            : null,
        isValid: window.isGiftProductValidList ? window.isGiftProductValidList[idx] : false,
      };
    });

    data = {
      // TODO
      items: cartItemsForTemplate,
      note: cartData.note,
      totalPrice: cartData.total_price,
      giftBadges: validGiftBadges, // array of all gift badge data
      showGiftProduct: isGiftProductValid && !giftCardInCart,
      recommendations: recommendationsWithCustomVariants,
      showFreeProductMessage: cartItemsForTemplate.some((item) => item.productType !== 'Digital Book'),
      hasUnavailableItems: cartItemsForTemplate.some((item) => item.isUnavailable),
      totalComparePrice,
      cartDiscount: cartData.cart_level_discount_applications.length,
      cartDiscounts: cartData.cart_level_discount_applications.map(function (obj) {
        return Object.keys(obj).reduce(function (acc, key) {
          if (key === 'total_allocated_amount') {
            acc[key] = Shopify.formatMoney(obj[key]);
          } else {
            acc[key] = obj[key];
          }
          return acc;
        }, {});
      }),
      totalCartDiscount:
        cartData.total_discount === 0
          ? 0
          : `You're saving ${Shopify.formatMoney(cartData.total_discount, settings.moneyFormat)}`,
      totalCartDiscountApplied: cartData.total_discount === 0 ? false : true,
    };

    const addBookDemoListeners = () => {
      const closeDemoModal = (e) => {
        e.target.closest('.free-book-demo__modal').classList.remove('is-open');
      };

      const addCloseBtnCliskListener = () => {
        const closeModalBtn = document.body.querySelector('.free-book-demo__modal-close');
        if (closeModalBtn) closeModalBtn.addEventListener('click', closeDemoModal);
      };

      const addBackdropClickListener = () => {
        if (document.querySelector('.free-book-demo__modal'))
          document.querySelector('.free-book-demo__modal').addEventListener('click', (e) => {
            const isBackdrop =
              e.target.classList.contains('free-book-demo__modal') ||
              e.target.classList.contains('free-book-demo__modal-container');

            if (isBackdrop) closeDemoModal(e);
          });
      };

      const addCloseDemoModalEventListeners = () => {
        addCloseBtnCliskListener();
        addBackdropClickListener();
      };

      const onDemoBtnClick = (e) => {
        const currentBookVariantId = Number(e.target.closest('.ajaxcart__row[data-variant-id]')?.dataset.variantId);
        const currentBookDemoContentEl = document.querySelector(`.free_book_demo_code_${currentBookVariantId}`);
        const demoModal = document.body.querySelector('.free-book-demo__modal');

        const removeCurrentBookHiidenClass = () => {
          currentBookDemoContentEl.classList.remove('free-book-demo--hidden');
        };

        const addBooksHiddenClass = () => {
          const booksDemoContentElems = document.querySelectorAll('.free-book-demo');
          booksDemoContentElems.forEach((bookContentEl) => bookContentEl.classList.add('free-book-demo--hidden'));
        };

        const renderCurrentBookContent = () => {
          const demoModalEl = document.querySelector('.free-book-demo__modal-content');
          const demoModalMarkup = document
            .querySelector(`template#free_book_demo_code_${currentBookVariantId}`)
            ?.content.querySelector('.free-book-demo').outerHTML;

          if (demoModalEl && demoModalMarkup) demoModalEl.insertAdjacentHTML('beforeend', demoModalMarkup);
        };

        const showCurrentDemoElContent = () => {
          if (currentBookDemoContentEl) {
            removeCurrentBookHiidenClass();
            return;
          }

          renderCurrentBookContent();
        };

        const renderDemoModal = () => {
          const demoModalMarkup = document
            .querySelector('template#free-book-demo-code')
            .content.querySelector('.free-book-demo-code').innerHTML;
          document.body.insertAdjacentHTML('beforeend', demoModalMarkup);
          addCloseDemoModalEventListeners();
        };

        if (demoModal) {
          addBooksHiddenClass();
          showCurrentDemoElContent(currentBookVariantId);
          demoModal.classList.add('is-open');
        } else {
          renderDemoModal();
          showCurrentDemoElContent(currentBookVariantId);
        }
      };

      const freeBookDemoBtnElems = $cartContainer[0].querySelectorAll('.free-book-demo__btn');
      freeBookDemoBtnElems.forEach((viewDemoBtn) => viewDemoBtn.addEventListener('click', onDemoBtnClick));
    };

    $cartContainer.empty();
    $cartContainer.append(template(data));
    addBookDemoListeners();
    $cartContainer.removeClass('is-loading');
    $(settings.cartContainer).removeClass('is-updating');

    cartCallback(cartData);
  };

  cartCallback = function (cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  calcTextAreaHeight = function (val) {
    let numberOfLineBreaks = (val.match(/\n/g) || []).length;
    let newHeight = 19 + numberOfLineBreaks * 16;
    return newHeight;
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    function updateQuantity(line, qty, id) {
      isUpdating = true;
      $(settings.cartContainer).addClass('is-updating');

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback, id, () => {
          isUpdating = false;
          $(settings.cartContainer).removeClass('is-updating');
        });
      }, 250);
    }

    // Make updateQuantity available globally for accessory removal
    window.updateQuantity = updateQuantity;

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, '')),
        id = $el.closest('.ajaxcart__product').data('id');

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        window.updateQuantity(line, qty, id);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove item
    $body.on('click', '.ajaxcart__remove', function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        id = $el.closest('.ajaxcart__product').data('id');

      if (line) {
        updateQuantity(line, 0, id);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, '')),
        id = $el.closest('.ajaxcart__product').data('id');

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, id);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });

    $body.on('keyup', 'textarea[name="note"]', (e) => {
      let textArea = e.target;
      textArea.style.height = `${calcTextAreaHeight(textArea.value)}px`;
    });
  };

  adjustCartCallback = function (cart, updateType) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart, updateType);
    }, 150);
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"].js-qty-input', $cartContainer).length) {
      $('input[type="number"].js-qty-input', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $('#AjaxQty').html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"].js-qty-input');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $('#JsQty').html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
  };

  $(document.body).on('rebuildCart.ajaxCart', function (event, cartData, type) {
    buildCart(cartData, type);
  });

  return module;
})(ajaxCart || {}, jQuery);
